import styled from 'styled-components';

import { getTextSize } from '@sorare/core/src/lib/text';

const StyledSvg = styled.svg`
  max-width: 100%;
  height: calc(7 * var(--unit));
  position: relative;
  z-index: 1;
`;
const StyledText = styled.text`
  font-size: var(--fs-56);
  font-weight: var(--t-bold);
`;

type Props = {
  name: Nullable<string>;
};

export const ResponsiveClubName = ({ name }: Props) => {
  const { width, height } = getTextSize(
    name || '',
    `bold 56px -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto',
    'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif`
  );
  return (
    <StyledSvg viewBox={`0 0 ${width} ${height}`}>
      <StyledText x={0} y={56} fill="currentColor">
        {name}
      </StyledText>
    </StyledSvg>
  );
};
